import page from "./_ImageDetectionPage/_ImageDetectionPage";

import { actions, reducer } from "./ducks";
import saga from "./saga";


import { Feature } from "features/interfaces";

export const imageDetectionFeature: Feature<typeof actions> = {
  reducer,
  saga,
  actions,
  page
};
